import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Services: [],
  Provider: {
    provider_category_detail: {
      SelectedService: [], // Ensure this is an empty array initially
      // other properties...
    },
  },
};

const serviceslice = createSlice({
  name: "services",
  initialState,
  reducers: {
    // selectedServices: (state, action) => {
    //   // Add new services to the existing array
    //   state.Services = [...state.Services, action.payload];
    // },
    selectedServicesNew: (state, action) => {
      // Add new services to the existing array
      state.Provider = action.payload;
    },
    // toggleService: (state, action) => {
    //   const { id } = action.payload;
    //   const index = state.Provider.SelectedService.findIndex(
    //     (service) => service.id === id
    //   );

    //   if (index !== -1) {
    //     // Remove service if it exists
    //     state.Provider.SelectedService.splice(index, 1);
    //   } else {
    //     // Add service if it doesn't exist
    //     state.Provider.SelectedService.push(action.payload);
    //   }
    // },
    resetServices: (state) => {
      // Reset Services array to empty
      state.Provider = {
        provider_category_detail: {
          SelectedService: [], // Ensure this is an empty array initially
        },
      };
    },
  },
});

export const {
  selectedServices,
  toggleService,
  resetServices,
  selectedServicesNew,
} = serviceslice.actions;
export default serviceslice.reducer;
